// extracted by mini-css-extract-plugin
export var button = "_df-4";
export var hasDarkBackground = "_df-7";
export var hasLightBackground = "_df-6";
export var iconWrapper = "_df-0";
export var large = "_df-2";
export var medium = "_df-1";
export var small = "_df-5";
export var xsmall = "_df-3";